'use client';
import React, { LegacyRef, useEffect, useRef, useState } from 'react';
import { Footer, Navbar, CosImage } from '@ssv-website/web-ui';
import { Image } from '@ssv-website/web-ui';
type IScrollRef = {
  active: number;
} & HTMLElement;
const INIT_ACTIVE = 1;
const ScreenScroll = ({ children }: { children: React.ReactElement[] }) => {
  const [active, setActive] = useState(INIT_ACTIVE);
  const ref = useRef<IScrollRef>(null);
  const { height } = useScreenSize();
  const isSupportSVH = useSVHSupport();

  useEffect(() => {
    const observerScroll = () => {
      if (ref.current) {
        const target = ref.current;
        const scrollTop = target.scrollTop;
        const currentActive = Math.ceil(scrollTop / target.offsetHeight);
        ref.current.active = currentActive;
        setActive(currentActive);
      }
    };

    if (ref.current) {
      ref.current.addEventListener('scroll', observerScroll);
      ref.current.active = INIT_ACTIVE;
      return () => {
        ref.current?.removeEventListener('scroll', observerScroll);
      };
    }
  }, []);
  // const changeNavStatus = ref.current && active > INIT_ACTIVE;
  return (
    <>
      <div className="fixed z-50">
        <Navbar
          boxStyle={{ position: 'fixed' }}
          // type={changeNavStatus ? 'dark' : 'light'}
        />
      </div>

      <div
        className={`h-screen overflow-y-scroll relative snap-mandatory overflow-x-hidden ${
          ref.current ? 'snap-y' : ''
        }`}
        id="scroll-screen"
        ref={ref as unknown as LegacyRef<HTMLDivElement>}
        style={!isSupportSVH ? { height: `${height}px` } : { height: '100svh' }}
      >
        {children}
        <div className="snap-center snap-always">
          <Footer theme="blue" />
        </div>
      </div>
    </>
  );
};

export default ScreenScroll;

interface ISectionProps {
  children: React.ReactNode;
  className?: string;
  cssContent?: string;
  showDownBtn?: boolean;
  iconType?: 'dark' | 'light';
  style?: React.CSSProperties;
}

export const Section = (props: ISectionProps) => {
  const {
    children,
    className,
    cssContent = 'pb-[5.5rem] pt-[72px]',
    showDownBtn = true,
    iconType = 'dark',
    style = {}
  } = props;

  return (
    <div
       style={style}
      className={`h-full snap-start snap-always flex relative items-center justify-center object-cover bg-cover bg-no-repeat ${className}`}
    >
      <div
        className={`h-full w-screen flex flex-col justify-center items-center box-border ${cssContent}`}
      >
        {children}
        {showDownBtn && <IconDown type={iconType} />}
      </div>
    </div>
  );
};
import icon_down from '@/assets/icons/icon_down.png';
import icon_down_white from '@/assets/icons/icon-down-white.png';
import { useScreenSize, useSVHSupport } from '@ssv-website/hooks';

export const IconDown = ({ type = 'dark' }: { type?: 'dark' | 'light' }) => {
  const ref = useRef<HTMLDivElement>(null);
  const onClick = () => {
    const scrollRef = document.getElementById('scroll-screen') as IScrollRef;
    if (scrollRef) {
      const toRef = scrollRef.children[scrollRef.active + 1] as Element & {
        offsetTop: number;
      };
      scrollRef.scrollTo({
        top: toRef.offsetTop,
        behavior: 'smooth',
      });
    }
  };
  const icon = type === 'dark' ? icon_down : icon_down_white;
  const iconPath =
    type === 'dark'
      ? '/ssv-home/assets/icons/icon_down.png'
      : '/ssv-home/assets/icons/icon-down-white.png';
  return (
    <div
      className="w-16 h-16 flex justify-center pb-12 absolute left-1/2 -translate-x-1/2 bottom-6 z-20"
      onClick={onClick}
      ref={ref}
    >
      <CosImage
        path={iconPath}
        fallbackSrc={icon}
        alt=""
        className="w-16 h-16 cursor-pointer"
      />
    </div>
  );
};
